export const INPUT_NAMES_ARRAY = [
  'RequestId',
  'PayInfo',
  'ReturnUrl',
  'CardId',
  'CardRcrMode',
  'Signature',
];
export const GPB_BANK = {
  bankId: 'gpb-extended',
  title: 'Банковской картой',
};
